import React from 'react';

import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';

import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';

const MuiCardBaseShortDescription: React.FC<{
    description?: string;
    truncateDescriptionAt?: number;
}> = ({ description, truncateDescriptionAt }) => {

  const truncateSx = truncateDescriptionAt ? getTextTruncationSx(truncateDescriptionAt) : {};

  return description ? <Typography
    variant='body2'
    color='text.secondary'
    sx={truncateSx}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
  /> : null;
};

export default MuiCardBaseShortDescription;
